import { jsx as _jsx } from "react/jsx-runtime";
const Skeleton = ({ width, height, className }) => {
    return (_jsx("div", { className: `${width} ${height} ${className} relative bg-secondary-100 dark:bg-neutral-700 rounded-8 overflow-hidden`, children: _jsx("div", { className: "absolute inset-0 bg-gradient-to-r from-transparent via-[#FFFFFF] to-transparent animate-shimmer opacity-50 dark:opacity-[16]" }) }));
};
export default Skeleton;
